var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M32 4.5V61","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M55 27L32 4 9 27","key":1})]));
}

ArrowUpInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
